import React, { useEffect, useState } from "react";
import TitleHeading from "../../../components/common/titleHeading";
import Password from "../../../components/common/password";
import { ErrorMsg } from "../../../components/common/error";
import Button from "../../../components/common/button";
import { useSelector } from "react-redux";
import { checkValidation, toastEmitter } from "../../../utils/utilities";
import { changePassword } from "../../../hooks/services/api-services";
import Input from "../../../components/common/input";
import { ALL_FEILDS, API_RESPONSE } from "../../../utils/app-constants";
import { handleFormInput } from "../../../utils/form-utils";
import { ErrorMessage } from "../../../utils/error-message-constant";
import { passwordRegex } from "../../../utils/form-regex";

const ChangePassword = ({ closeRef, closeModal }) => {
  const { value } = useSelector((state) => state?.loggedUser);
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState();

  const [changepasswordPayload, setChangepasswordPayload] = useState({
    oldPassword: "",
    newPassword: "",
    email: value?.email,
  });

  useEffect(() => {
    if (closeModal) {
      clearField();
    }
  }, [closeModal]);

  // api call
  const changeUserPassword = async () => {
    setLoading(true);
    try {
      const response = await changePassword(changepasswordPayload);
      if (response?.data?.responseCode == 200) {
        setLoading(false);
        toastEmitter("success", response?.data?.message);
        closeRef?.current?.click();
        clearField();
      } else {
        setLoading(false);
        toastEmitter(
          "error",
          response?.data?.message || API_RESPONSE.MESSAGE_500
        );
        clearField();
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  const checkValidField = (obj) => {
    const valid = (obj) => {
      return (
        obj["oldPassword"] &&
        obj["newPassword"] &&
        !formError?.newPasswordStatus &&
        !formError?.oldPasswordStatus &&
        obj["oldPassword"] !== obj["newPassword"]
      );
    };

    if (valid(obj)) {
      return false;
    } else {
      return true;
    }
  };

  const clearField = () => {
    setChangepasswordPayload({
      ...changepasswordPayload,
      oldPassword: "",
      newPassword: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setChangepasswordPayload(handleFormInput(e, changepasswordPayload));

    if (name === "oldPassword" || name === "newPassword") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Password,
        passwordRegex,
        formError,
        setFormError
      );
    }
  };

  const handleSubmit = () => {
    const isCheck = checkValidField(changepasswordPayload);
    if (isCheck) {
      return toastEmitter("error", ALL_FEILDS?.REQUIRED);
    } else {
      changeUserPassword();
    }
  };
  return (
    <>
      <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
        <div className="jana_login_content_leftsec h-100">
          <div className="heading-section">
            <TitleHeading
              heading="CHANGE PASSWORD?"
              subHeading="Set the new password for your account so you can login and access all the features."
            />
            <div className="row mb-3">
              <div className="col-12">
                <Input
                  lableName="Email ID"
                  typeName="email"
                  className=""
                  placeholder="Enter Your Email"
                  Name="email"
                  info_Icon={false}
                  disabled={true}
                  value={changepasswordPayload?.email}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Password
                  Name="oldPassword"
                  labelName="Old Password"
                  placeholder="Enter Your Old Password"
                  value={changepasswordPayload.oldPassword}
                  handleChange={handleChange}
                  error={formError?.oldPasswordStatus}
                />
                <ErrorMsg error={formError?.oldPassword} />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12">
                <Password
                  Name="newPassword"
                  labelName="New Password (Not be same as old password)"
                  placeholder="Enter Your New Password"
                  tooltipClassName="changepassword-toltip-position"
                  value={changepasswordPayload.newPassword}
                  handleChange={handleChange}
                  error={formError?.newPasswordStatus}
                  info_Icon={true}
                  id="my-tooltip-confirm-password"
                  tooltipContent="Password must be at least 8 characters long, contain both uppercase and lowercase letters, include at least one number, and have at least one special character."
                />
                <ErrorMsg error={formError?.newPassword} />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Button
                  buttonName="Change Password"
                  loader={loading}
                  buttonDisabled={checkValidField(changepasswordPayload)}
                  buttonStyle="submitbtn w-100 mt-3 mx-0 mb-3"
                  handleClick={handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
